/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import React, { useState } from "react";
import { Button, Col, Form, Input, Row, Space } from "antd";
import { createCustomerAccount, loginUser } from "api/services/userAuth.api";
import Heading from "components/Common/Heading/Heading";
import { CreateCustomerAccountData, UserData } from "interfaces/ApiInterface/ILoginFormData";
import { notificationController } from "components/Common/Notification/Notification";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import "./Register.scss";
import { setUserDetail } from "store/slices/user.slice";
import { useAppSelector } from "hooks/reduxHooks";
import { ROUTES_PATH } from "routes/Routes.Constant";

const Register = () => {
  const dispatch = useDispatch();
  const [isLoading, setLoading] = useState(false);
  const navigate = useNavigate();
  const localPortalData: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);

  const queryParams = new URLSearchParams(location.search);
  const redirectUrl = queryParams.get("redirect_url");
  const decodedRedirectUrl = redirectUrl ? decodeURIComponent(redirectUrl) : "";

  // console.log(decodedRedirectUrl);

  const handleSubmit = async (values: UserData) => {
    setLoading(true);
    const portalId: number | null = localPortalData?.lockerPortalDetails?.PortalId || null;
    if (portalId) {
      const data: CreateCustomerAccountData = {
        IsWebStoreUser: true,
        PortalId: portalId,
        UserVerificationTypeCode: "NoVerificationCode",
        Email: values?.username,
        User: {
          Username: values?.username,
          Email: values?.username,
          Password: values?.password,
        },
      };

      createCustomerAccount(data)
        .then(() => {
          loginUser(values, portalId)
            .then((response) => {
              const data = response?.User;
              dispatch(setUserDetail(data?.AspNetUserId));
              localStorage.setItem("UserRecord", JSON.stringify(data));
              notificationController.success({
                message: "Registered Successfully",
              });
              setLoading(false);
              if(decodedRedirectUrl){
                navigate(decodedRedirectUrl);
              }else{
                navigate(ROUTES_PATH.HOMEPAGE);
              }
            })
            .catch(() => {
              notificationController.error({
                message: "Incorrect email or password.",
              });
              setLoading(false);
            });
        })
        .catch((error) => {
          const errorMessage =
            error?.response?.data?.ErrorMessage || "An unexpected error occurred.";
          notificationController.error({
            message: errorMessage,
          });
          setLoading(false);
        });
    }
  };

  const handleCancel = () => {
    navigate(ROUTES_PATH.LOGIN);
  };

  return (
    <div className="page-content-wrapper p-30">
      <Row gutter={15} className="global-form-container">
        <Col span={12} xs={24} md={12} xxl={12} lg={12}>
          <Heading titleText="Sign-up to Create an Account" titleClass="global-form-heading" />
          <div className="form-wrapper">
            <Form
              layout="vertical"
              name="login"
              onFinish={handleSubmit}
              initialValues={{ remember: true }}
              autoComplete="off"
            >
              <Form.Item
                label={
                  <span className="wrapper">
                    Username/Email <span className="text-danger">*</span>
                  </span>
                }
                name="username"
                rules={[
                  { required: true, message: "Username/Email address is required." },
                  { type: "email", message: "Please enter a valid Username/Email address." },
                ]}
                className="input-label"
              >
                <Input className="form-input" />
              </Form.Item>

              <Form.Item
                label={
                  <span className="wrapper">
                    Password <span className="text-danger">*</span>
                  </span>
                }
                name="password"
                rules={[
                  {
                    required: true,
                    message: "Password is required.",
                  },
                  () => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.resolve();
                      }
                      if (
                        value.length < 8 ||
                        !/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                          value
                        )
                      ) {
                        return Promise.reject(
                          new Error(
                            "Password must be at least 8 alphanumeric characters and contain at least one number."
                          )
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
                className="input-label"
              >
                <Input.Password className="form-input" />
              </Form.Item>
              <Form.Item
                name="confirm"
                label={
                  <span className="wrapper">
                    Confirm Password <span className="text-danger">*</span>
                  </span>
                }
                dependencies={["password"]}
                rules={[
                  {
                    required: true,
                    message: "You must confirm your password.",
                  },
                  ({ getFieldValue }) => ({
                    validator(_, value) {
                      if (!value) {
                        return Promise.reject();
                      }
                      if (
                        value.length < 8 ||
                        !/^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9!@#$%^&*(),.?":{}|<>]{8,}$/.test(
                          value
                        )
                      ) {
                        return Promise.reject(
                          new Error(
                            "Password must be at least 8 alphanumeric characters and contain at least one number."
                          )
                        );
                      }
                      if (value !== getFieldValue("password")) {
                        return Promise.reject(
                          new Error("The two passwords that you entered do not match.")
                        );
                      }
                      return Promise.resolve();
                    },
                  }),
                ]}
              >
                <Input.Password />
              </Form.Item>

              <Form.Item className="global-form-action">
                <Space size={"middle"}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={isLoading}
                    className={isLoading ? "btn-disabled register-btn" : "register-btn"}
                  >
                    Register
                  </Button>
                  <Button className="cancel-btn" onClick={handleCancel}>
                    Cancel
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default Register;